// eslint-disable-next-line import/prefer-default-export
export const validatePassword = (pass) => {
  const re = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=!?*()])[a-zA-Z0-9@#$%^&+=!?*()]{8,}$/;
  return re.test(pass);
};
